import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss'],
})
export class PopupModalComponent {
  @Input() innerModal = false; // set true if your Modal is inside another modal
  @Output() closeModal: EventEmitter<undefined> = new EventEmitter<undefined>();
}
